<template>
  <div class="menu-panel-group">
    <h3>
      <a v-if="header.url" :href="header.url" :target="header.target">{{ header.name }}</a>
      <span v-else>{{ header.name }}</span>
    </h3>
    <LinkList :links="links" :unstyle="true" />
  </div>
</template>
<script>
  import LinkList from '@/components/common/LinkList.vue'

  export default {
    name: 'MenuPanelGroup',
    props: {
      links: Array,
      header: Object,
    },
    components: {
      LinkList
    }
  }
</script>

<style lang="scss">
  .menu-panel-group {
    padding: 0 0 20px;
    break-inside: avoid;
    
    h3 {
      font-family: 'Open Sans', 'Arial';
      font-size: 16px;
      margin: 0px;
      border-bottom: 1px solid #b7b7b7;

      a,
      span {
        display: block; 
        padding: 8px 0 8px;
      }
      a,
      a:visited {
        // color deviated from global #0046ad; 
        // because of contrast minimum from regular
        // normal heading #000. This combo is 3.13 : 1
        color: #1357BE;

        &:hover {
          background: #f1f1f1;
        }
      }
    }
    li a {
      color: #000;
      padding: 6px 0;
      display: block;
    }
  }
</style>
